export default __webpack_public_path__ + "static/media/basry-logo.f63409c7.png";